<template>
  <v-container :class="containerClass" fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="itemList.data"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="itemList.meta.total"
          :footer-props="defaultDataTableFooterProps"
          item-key="id"
        >
          <template #top>
            <v-sheet>
              <v-container fluid class="pa-4">
                <v-row align="center">
                  <v-col md="6" cols="12">
                    <h2>Lesson Plan List</h2>
                  </v-col>
                  <v-col md="6" cols="12" class="text-right">
                    <v-btn
                      color="primary"
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      :href="$route('lesson-plans.create')"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-plus</v-icon
                      >Tambah
                    </v-btn>
                    <v-btn
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      @click="showFilters = !showFilters"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-filter</v-icon
                      >{{ showFilters ? 'Hide' : 'Show' }} Filter
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
            <v-divider></v-divider>
            <v-expand-transition>
              <v-sheet v-show="showFilters" color="grey lighten-5">
                <v-container fluid class="pa-4">
                  <v-row>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Name</div>
                      <v-text-field
                        v-model="filters.name"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Name"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Curriculum</div>
                      <v-select
                        v-model="filters.curriculum_id"
                        :items="curriculums"
                        item-text="name"
                        item-value="id"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Curriculum"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Status</div>
                      <v-select
                        v-model="filters.status"
                        :items="statusOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Status"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Created At</div>
                      <date-picker
                        v-model="filters.created_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Updated At</div>
                      <date-picker
                        v-model="filters.updated_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>
              </v-sheet>
            </v-expand-transition>
          </template>
          <template #[`item.curriculum`]="{ item }">
            {{ item.curriculum.name }}
          </template>
          <template #[`item.status`]="{ item }">
            <v-chip
              :color="lessonPlanStatusProps(item.status, 'color')"
              small
              dark
            >
              <strong>
                {{ lessonPlanStatusProps(item.status, 'text') }}
              </strong>
            </v-chip>
          </template>
          <template #[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.updated_at`]="{ item }">
            {{ formatDate(item.updated_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.action`]="{ item }">
            <div class="text-right">
              <v-btn
                small
                color="secondary"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                :href="$route('lesson-plans.detail', item.id)"
              >
                <v-icon small>mdi-eye</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;View</span>
              </v-btn>
              <v-btn
                small
                color="warning"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                :href="$route('lesson-plans.update', item.id)"
              >
                <v-icon small>mdi-pencil</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Edit</span>
              </v-btn>
              <v-btn
                small
                color="error"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                @click="showDeleteDialog(item)"
              >
                <v-icon small>mdi-delete-forever</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Delete</span>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <lesson-plan-delete-dialog
      v-if="deleteDialog.show"
      v-model="deleteDialog.show"
      :lesson-plan="deleteDialog.item"
      @delete="getListData"
    >
    </lesson-plan-delete-dialog>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import LessonPlanDeleteDialog from '@components/LessonPlan/DeleteDialog'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import constant from '@/constant'
import { ListParams } from '@/models'
import utils from '@/utils'

export default {
  name: 'LessonPlan',
  components: {
    LessonPlanDeleteDialog,
  },
  layout: LayoutDashboard,
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Curriculum', value: 'curriculum' },
        { text: 'Rank', value: 'rank' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Created At', value: 'created_at' },
        { text: 'Updated At', value: 'updated_at' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      showFilters: true,
      filters: {
        name: null,
        status: null,
        curriculum_id: null,
        created_at: [],
        updated_at: [],
      },
      deleteDialog: {
        show: false,
        item: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      itemList: 'lessonPlan/list',
      isLoading: 'lessonPlan/isListLoading',
      curriculumList: 'curriculum/list',
      isCurriculumListLoading: 'curriculum/isListLoading',
      listParams: 'lessonPlan/listParams',
    }),
    statusOptions() {
      return constant.lessonPlanStatusOptions
    },
    curriculums() {
      return this.curriculumList.data
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      getItemList: 'lessonPlan/getList',
      getCurriculumList: 'curriculum/getList',
    }),
    ...mapMutations({
      setListParams: 'lessonPlan/setListParams',
    }),
    init() {
      this.getCurriculumList({
        status: 'ACTIVE',
        sort: ['rank,asc'],
      })
      if (this.listParams) {
        _.merge(this.filters, this.listParams.filters)
        _.merge(this.options, this.listParams.options)
      }
    },
    getListData() {
      const listParams = new ListParams(this.filters, this.options)
      this.getItemList(utils.toServerSideQuery(listParams))
      this.setListParams(listParams)
    },
    showDeleteDialog(item) {
      this.deleteDialog.item = item
      this.deleteDialog.show = true
    },
  },
}
</script>
